import { InstructionAttribute } from '../../components/script-editor/tools/types';
import InstructionTypeGetter from './InstructionTypeGetter';
import { Project } from '../../types/items';

type Params = {
  project: Project | null;
};

class InstructionGenerator {
  static generate(value: string, params: Params) {
    const div = document.createElement('div');
    div.innerHTML = value;
    const instructions = div.querySelectorAll(`[${InstructionAttribute.instructionId}]`);
    if (instructions.length === 0) {
      return value;
    }
    instructions.forEach((item) => {
      const instructionType = InstructionTypeGetter.get(item as HTMLElement);
      if (instructionType) {
        if (instructionType === 'nameScript') {
          // eslint-disable-next-line no-param-reassign
          item.innerHTML = this.nameScript(item as HTMLElement, params);
        }
      }
    });
    return div.innerHTML;
  }

  static nameScript(element: HTMLElement, params: Params) {
    const nameId = Number(element.getAttribute(InstructionAttribute.data));
    const { project } = params;
    if (!Number.isNaN(nameId) && project) {
      switch (nameId) {
        default:
          return '';
        case 0:
          return project.ref.user_owner.first_name;
        case 1:
          return project.ref.user_owner.full_name_first_last;
        case 2:
          return project.ref.organization?.common_name || 'Error: no organization specified';
      }
    }
    return '';
  }
}

export default InstructionGenerator;
